import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const WhatIfBudgeting = () => {
	return <PlaceholderView pageType={PageType.WhatIfBudgeting} text="Budgeting" />;
};

export default WhatIfBudgeting;
